module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-7-sea-003.8049490f.json").toString();